import { render, staticRenderFns } from "./LogoOrPlaceholder.vue?vue&type=template&id=0586281a&scoped=true&lang=pug"
import script from "./LogoOrPlaceholder.vue?vue&type=script&lang=js"
export * from "./LogoOrPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LogoOrPlaceholder.vue?vue&type=style&index=0&id=0586281a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586281a",
  null
  
)

export default component.exports